import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import RoundedButton from 'components/Shared/RoundedButton';
import i18nInitialState from '../../config/translations';

const EMAIL = 'support@test.localhost';

const useStyles = makeStyles((theme) => ({
  contactBtn: {
    border: `2px solid ${theme.palette.error.light}`,
    color: theme.palette.error.main,
    backgroundColor: theme.colors.errorPinkLight,
    marginRight: theme.spacing(1),
  },
}));

const SupportButton = ({ options }) => {
  const { correlationUUID, userUUID } = options;
  const classes = useStyles();
  const userStr = userUUID ? `UserUUID: ${userUUID}` : '';

  const emailSubject = i18nInitialState.en.errors.supportRequest;
  const emailBody = `${i18nInitialState.en.errors.pleaseEnterDescription}

----------------------

CorrelationUUID: ${correlationUUID}
Timestamp: ${Date.now()}
${userStr}
  `;

  return (
    <RoundedButton
      variant='outlined'
      className={classes.contactBtn}
      component='a'
      href={`mailto:${EMAIL}?subject=${encodeURIComponent(
        emailSubject,
      )}&body=${encodeURIComponent(emailBody)}`}
    >
      {i18nInitialState.en.btn.contactSupport}
    </RoundedButton>
  );
};

SupportButton.propTypes = {
  options: PropTypes.shape({
    correlationUUID: PropTypes.string.isRequired,
    userUUID: PropTypes.string,
  }).isRequired,
};

export default SupportButton;
